<template>
  <div id="footer">
    <footer class="footer">
      <div class="container">
        <div style="text-align:center;">
          <p style="color:black;">
            Copyright © 2008-2018 FineHedgefunds. All Rights Reserved. Email:
            huayinjingzhi@163.com
          </p>
        </div>
        <div style="text-align:center;">
          <p style="color:black;">
            版权所有 © 深圳市华银精治资产管理有限公司 粤ICP备14083240号
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  }
};
</script>

<style scoped>
.footer {
  position: relative;
  bottom: 0;
  width: 100%;
  height: 100px;
  background-color: #f5f5f5;
}

.footer p {
  margin: 0;
  padding: 10px 0 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue